import React from 'react';
import { STACK_ALIGN, STACK_DIRECTION, STACK_GAP, StackView } from "../../StackView";
import { Toolbar, TOOLBAR_VIEW_TYPE } from "../../Toolbar";
export var prepareDoubleToolbar = function (items) {
    return items.reduce(function (acc, curr) {
        if (curr.isAction) {
            acc.actions.push(curr);
            return acc;
        }
        acc.filters.push(curr);
        return acc;
    }, { filters: [], actions: [] });
};
export var doubleToolbar = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.viewFilters, viewFilters = _c === void 0 ? TOOLBAR_VIEW_TYPE.spotted : _c, viewActions = _b.viewActions;
    return function (_a) {
        var disabled = _a.disabled, items = _a.items, groups = _a.groups, payload = _a.payload, buildIn = _a.buildIn;
        var preparedItems = prepareDoubleToolbar(items);
        return (React.createElement(StackView, { direction: STACK_DIRECTION.column, gap: STACK_GAP.none, align: STACK_ALIGN.fill },
            !!preparedItems.filters.length && (React.createElement(Toolbar, { view: viewFilters, items: preparedItems.filters, buildIn: buildIn, groups: groups, payload: payload, disabled: disabled })),
            !!preparedItems.actions.length && (React.createElement(Toolbar, { view: viewActions, buildIn: buildIn, items: preparedItems.actions, groups: groups, payload: payload, disabled: disabled }))));
    };
};
//# sourceMappingURL=doubleToolbar.js.map